export const EXTERNAL_BASE_URL = process.env.NEXT_PUBLIC_EXTERNAL_BASE_URL
export const MOCK_API = process.env.NEXT_PUBLIC_MOCK_API === 'true'
export const BUCKET_URL = process.env.NEXT_PUBLIC_BUCKET_URL
